import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/cart-add-inv.svg")